import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DialogRef, DIALOG_DATA } from "@angular/cdk/dialog";

export interface ReopenConfirmationData {
  areaName?: string;
  issueText: string;
}

@Component({
  selector: "app-reopen-confirmation-modal",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./reopen-confirmation-modal.component.html",
  styleUrls: ["./reopen-confirmation-modal.component.scss"]
})
export class ReopenConfirmationModalComponent {
  areaName: string = "";
  issueText: string = "";
  
  constructor(
    private dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) private data: ReopenConfirmationData
  ) {
    this.areaName = this.data.areaName || "";
    this.issueText = this.data.issueText || "";
  }

  onReopen(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onKeyDown(event: KeyboardEvent): void {
    // Handle Escape to cancel
    if (event.key === "Escape") {
      event.preventDefault();
      this.onCancel();
    }
  }
}
